import * as areaApi from './therapeuticAreaApi';
import * as areaActions from './therapeuticAreaActions';

export function getAreaList() {
  return (dispatch) => {
    areaApi
      .getAreaList()
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(areaActions.setAreaList(response.data));
        }
      });
  };
}

export function getArea(areaId) {
  return (dispatch) => {
    areaApi
      .getArea(areaId)
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(areaActions.setArea(response.data));
        }
      });
  };
}

export function addArea(area, cb) {
  return (dispatch) => {
    areaApi
      .addArea(area)
      .then((response) => {
        if (response && response.status === 201 && response.data) {
          dispatch(areaActions.addArea(response.data));
          cb();
        }
      });
  };
}

export function updateArea(area, cb) {
  return (dispatch) => {
    areaApi
      .updateArea(area)
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(areaActions.updateArea(response.data));
          cb();
        }
      });
  };
}

export function deleteArea(area, cb) {
  return (dispatch) => {
    areaApi
      .deleteArea(area)
      .then((response) => {
        if (response && response.status === 204) {
          dispatch(areaActions.deleteArea(area.category, area.id));
          cb();
        }
      });
  };
}



// WEBPACK FOOTER //
// ./src/therapeuticArea/therapeuticAreaServices.js